import { OfferOptionUsageType } from '../Types/offerOptionsMappingsTypes';

export const offerOptionUsageTypeLabels: Record<OfferOptionUsageType, string> = {
  [OfferOptionUsageType.Info]: 'Informacyjna',
  [OfferOptionUsageType.Mandatory]: 'Obligatoryjna',
  [OfferOptionUsageType.Additional]: 'Dodatkowa',
};
